import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onConsultationClick: () => void;
}

const CTASection = ({ onConsultationClick }: CTASectionProps) => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-secondary to-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Heading */}
          <h2 className="font-headline font-bold text-3xl lg:text-5xl mb-6">
            Ready to Transform Your IT Infrastructure?
          </h2>
          <p className="text-xl lg:text-2xl text-white/90 font-body mb-8">
            Get a comprehensive IT assessment and discover how we can help your business grow with technology
          </p>

          {/* Value Props */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {[
              { icon: 'ClockIcon', text: 'Free 60-minute consultation' },
              { icon: 'DocumentTextIcon', text: 'Detailed assessment report' },
              { icon: 'UserGroupIcon', text: 'No obligation, no pressure' }
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
                <Icon name={item.icon as any} size={20} variant="outline" className="text-accent" />
                <span className="text-sm font-body font-semibold">{item.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={onConsultationClick}
              className="flex items-center space-x-2 px-8 py-4 bg-accent hover:bg-accent/90 text-white rounded-lg font-cta font-bold text-lg shadow-elevated hover:shadow-card transition-all duration-300 transform hover:scale-105"
            >
              <Icon name="CalendarIcon" size={24} variant="outline" />
              <span>Schedule Free Assessment</span>
            </button>
            <Link
              href="/contact"
              className="flex items-center space-x-2 px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg font-cta font-semibold text-lg border-2 border-white/30 transition-all duration-300"
            >
              <Icon name="PhoneIcon" size={20} variant="outline" />
              <span>Call Us Now</span>
            </Link>
          </div>

          {/* Trust Indicator */}
          <div className="mt-12 flex items-center justify-center space-x-2">
            <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-accent" />
            <p className="text-sm font-body">
              Join 500+ businesses that trust Centronics IT Soloutions for their IT needs
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;